<button type="button" class="ev-button primary itinerary-dropdown ev-plain-button" data-testid="itinerary-toggle-btn" (click)="toggle()" [class.active]="itineraryDropdown()"
  [hidden]="loadingMap || noRoute">
  <span class="itinerary-text">
    {{ languageService.languageJSON.InfoSidebar_Tooltip_Itinerary }}
  </span>
  <span class="itinerary-icon" aria-hidden="true"></span>
</button>
@if (itineraryDropdown()) {
<div class="itinerary" data-testid="itinerary-list-container" [hidden]="loadingMap || noRoute">
  @for (turn of routeData?.Turns ?? []; track turn; let i = $index) {
  <div class="turn-element-outer">
    <button type="button" class="turn-element ev-plain-button" [attr.data-testid]="'itinerary-turn-' + i" (click)="onTurnClick(turn)" [class.active]="i == itineraryNextTurnIdx">
      <span class="turn-leftside">
        <span class="turn-leftside-element">
          <span class="turn-icon" [class.combined-turn]="turn.CombinedTurn">
            <span class="turn-svg" aria-label="turn"
              [appSvgRecolor]="'assets/icons/default/turn/' + turn.Icon[0]"
              [recolorGradient]="baseGradientStops"></span>
          </span>
          <span class="turn-instruction">
            <span>{{ turn.Instruction[0] }}</span>
          </span>
        </span>
        @if (turn.CombinedTurn) {
        <span class="turn-leftside-element">
          <span class="turn-icon combined-turn">
            <span class="turn-svg" aria-label="turn"
              [appSvgRecolor]="'assets/icons/default/turn/' + turn.Icon[1]"
              [recolorGradient]="baseGradientStops"></span>
          </span>
          <span class="turn-instruction">
            <span>{{ turn.Instruction[1] }}</span>
          </span>
        </span>
        }
      </span>
      @let d = turnDistanceDisplay(turn.DistanceFromStart);
      <span class="distance">
        @if (d.isThousands) {
          {{ d.value | turnValueIntegerThousands }}
        } @else {
          {{ d.value | valueInteger }}
        }
        {{ d.unit.toUpperCase() }}
      </span>
    </button>
  </div>
  }
</div>
}
